"use client";

import { useCallback } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { usePdfFile } from '@/lib/pdf-editor/FileContext';
import { ToolLayout } from '@/components/tools/ToolLayout';
import { FileUploader } from '@/components/ui/FileUploader';
import { tools } from '@/config/tools';
import { getLocaleFromPathname, withLocale } from '@/lib/i18n';
import { getSiteContent } from '@/lib/site-content';

const PDF_EDITOR_TOOL = tools.find(t => t.id === 'edit-pdf')!;

export default function PDFUploadPage() {
  const router = useRouter();
  const pathname = usePathname() || "/";
  const locale = getLocaleFromPathname(pathname);
  const content = getSiteContent(locale).toolsPage;
  const { setPdfFile } = usePdfFile();

  const handleFilesSelected = useCallback((files: File[]) => {
    if (files.length > 0) {
      const file = files[0];
      if (file.type !== 'application/pdf') {
        alert(content.invalidPdfFile);
        return;
      }
      setPdfFile(file);
      router.push(withLocale(locale, '/document/create'));
    }
  }, [content.invalidPdfFile, locale, setPdfFile, router]);

  return (
    <ToolLayout tool={PDF_EDITOR_TOOL}>
      <div className="flex flex-col gap-8">
        <FileUploader
          accept=".pdf,application/pdf"
          onFilesSelected={handleFilesSelected}
          className="min-h-[400px]"
        />
      </div>
    </ToolLayout>
  );
}
